// @core/api/endpoints/document/list_acknowledgments.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListAcknowledgmentsResponse,
} from '../../../types/document';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/document';

/**
 * List acknowledgments
 * Returns acknowledgment status for all requested actors.
 */
export async function ListAcknowledgments(
  target_type: string,
  target_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListAcknowledgmentsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/documents/:target_type/:target_id/acknowledgments`;
  requestPath = requestPath.replace(':target_type', encodeURIComponent(target_type));
  requestPath = requestPath.replace(':target_id', encodeURIComponent(target_id));
  const requestOptions = options;
  return client.get<ListAcknowledgmentsResponse>(requestPath, { ...requestOptions, params });
}
